//include 10
jQuery(function () {

    var privateFunctions = {
        getGroupContainer(group) {
            var groupContainer = group;
            var groupContainerSelector = group.data("group-container") || null;

            if (!!groupContainerSelector) {
                groupContainer = $(groupContainerSelector);
            }
            return groupContainer;
        },
        showHideTourLength() {
            window.pixelpoint.searchform.showHideTourLength();
        },
        showHideTitle() {
            var headline = $(".group-names-headline");
            if ($(".group-names-container > li").length > 0) {
                headline.removeClass("hide");
                headline.closest(".element-wrapper").removeClass("hide");
            } else {
                headline.addClass("hide");
                headline.closest(".element-wrapper").addClass("hide");
            }
        },
        recalculateGroupIndices(group) {
            var index = 0;

            var groupContainer = this.getGroupContainer(group);

            groupContainer.find(".groups section").each(function () {
                $(this).find("[name]").each(function () {
                    var name = $(this).attr("name");
                    name = name.replace(/\[\d+\]/, `[${index}]`);
                    $(this).attr("name", name);
                });
                index++;
            });
            if (groupContainer.find(".groups section").length == 0)
                groupContainer.find(".groups").hide();
        },
        bindGroupEvents(group, $this) {
            var groupContainer = this.getGroupContainer(group);
            group.on("click", ".remove-group", function (e) {
                e.preventDefault();
                e.stopPropagation();
                var nameContainer = $(e.target).closest("li");
                var groupId = nameContainer.data("group-id");
                if (!groupId)
                    return;
                //var a = $(e.target).closest(".dropdown-group-container")
                var a = privateFunctions.getGroupContainer(group);

                var b = a.find(`.groups section[data-group-id='${groupId}']`)
                b.remove();
                nameContainer.remove();
                privateFunctions.recalculateGroupIndices(group);
                privateFunctions.showHideTourLength();
                privateFunctions.showHideTitle();
                privateFunctions.showHideFilterIcon(group);
                privateFunctions.addHideShowIcon(group);

                let groups = $(".group-names-container li");
                let allIds = [];
                groups.each((index, el) => {
                    let id = $(el).data('group-id');
                    if (!!id && id != groupId) {
                        allIds.push(id);
                    }
                });
                window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.categoryChanged, [allIds]);
            });
            groupContainer.on("click", ".close-group", function (e) {
                e.preventDefault();
                groupContainer.find(".groups").hide();
                groupContainer.parent().find(".group-names-container li.active").removeClass("active");
            });
            group.on("click", ".group-names-container li", function () {
                var $this = $(this);

                //******************************************************** */
                if ($this.hasClass("active")) {
                    groupContainer.find(".groups").hide();
                    $this.removeClass("active");
                    return;
                }
                groupContainer.find(".groups").show();
                var searchHeight = group.closest(".search").height();
                var searchOffset = group.closest(".search").offset().top;
                var groupOffset = groupContainer.find(".groups").offset().top;
                var realHeight = searchHeight - (groupOffset - searchOffset);
                groupContainer.find(".groups").css("max-height", realHeight);
                //******************************************************** */

                var groupId = $this.data("group-id");
                if (!groupId)
                    return;
                group.find(".group-names-container [data-group-id]").removeClass("active");

                $this.addClass("active");

                groupContainer.find(".groups section").removeClass("active");

                groupContainer.find(`.groups section[data-group-id='${groupId}'] .control .brandenbutton.search-button`).closest('.control').addClass("ignore");

                var controlsCount = groupContainer.find(`.groups section[data-group-id='${groupId}'] .control`).not(".ignore").length;
                if (controlsCount == 0) {
                    groupContainer.find(".groups").css("height", 0);
                    return;
                } else {
                    groupContainer.find(".groups").css("height", '');
                }

                groupContainer.find(`.groups section[data-group-id='${groupId}']`).addClass("active");
                groupContainer.find(".more-wrapper").each(function () {
                    var showMore = $(this).data("show-more");
                    if (!!showMore.init)
                        showMore.init();
                });

            });

            groupContainer.on("click", ".reset-group", function (e) {
                e.preventDefault();
                var container = $(e.target).closest('section[data-group-id]');
                container.find(".control").each(function () {
                    var formFunctionsElement = $(this).find("[data-form-element-functions-added]");
                    if (formFunctionsElement.length > 0) {
                        var formFunctions = formFunctionsElement.data("form-element-functions");
                        if (!!formFunctions.reset)
                            formFunctions.reset();
                    } else {
                        $(this).find("input[type='text']").each(function () {
                            $(this).val(function () {
                                return this.defaultValue;
                            });
                        });
                        $(this).find("input[type='select']").each(function () {
                            $(this).val('').change();
                        });
                        $(this).find("input[type='checkbox']").each(function () {
                            $(this).prop('checked', false);
                        });
                        $(this).find("input[type='radio']").each(function () {
                            $(this).prop('checked', false);
                        });
                    }
                });
            });
        },
        addGroupElement($this, group, parent, templateUrl) {
            if (!parent || !parent.name) {
                return;
            }
            var groupContainer = privateFunctions.getGroupContainer(group);
            var alreadyIncluded = false;
            group.find(".group-names-container [data-group-id]").each(function () {
                var groupId = $(this).data("group-id");
                if (groupId == parent.id) {
                    alreadyIncluded = true;
                    return false;
                }
            });
            if (alreadyIncluded) {
                return;
            }

            var onlyHeader = $this.is("[data-only-header]");
            var headerHiddenName = $this.data("header-hidden-name");

            var dataExternalId = "";
            if (!!parent.externalId) {
                dataExternalId = `data-external-id="${parent.externalId}"`;
            }

            if (!!onlyHeader) {
                var controlsCount = groupContainer.find(`.groups section[data-group-id='${parent.id}'] .control`).length;
                group.find(".group-names-container li.active").removeClass("active");

                var deleteCategoryTranslation = window.ppt.translate("search.remove.category", "Kategorie löschen");
                var showCategoryFilterTranslation = window.ppt.translate("search.filter.show", "Filter für Kategorie anzeigen");

                group.find(".group-names-container").append(`
                    <li data-group-id="${parent.id}" ${dataExternalId}>
                        <span class="filter-content">
                            <i class="remove-group" title="${deleteCategoryTranslation}">✕</i>
                            <span class="ttip-blue tooltipstered" title="${showCategoryFilterTranslation}">
                                 <span class="filter-name-group">
                                     <span class="filter-name"> ${parent.name}</span>
                                     <i class="icon-filter"></i>
                                 </span>
                            </span>
                        </span>
                        <input type="hidden" name="${headerHiddenName}" value="${parent.id}" />
                    </li>`);

                //window.pixelpoint.tooltip.init(group.find(".group-names-container li"));
                window.pixelpoint.tooltip.init(group.find(".group-names-container li span"));
                group.parent().parent().parent().find("button.search-button").html(window.ppt.translate("button.now.searchagain", "Erneut suchen!"));
                privateFunctions.addHideShowIcon(group, true);
                return;
            }

            var index = group.data("count");
            if (!index) {
                index = 0;
            }

            var loader = groupContainer.find('.loader[data-loader]');
            var loaderFunctions = loader.data("exposed");
            if (!!loaderFunctions)
                loaderFunctions.show();

            var url = templateUrl;
            url = url.replace("[[parent.id]]", parent.id);
            url = url.replace("[[parent.name]]", parent.name);
            url = url.replace("[[index]]", index);

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'html',
                data: {}
            })
                .done(function (response) {
                    if (!response)
                        return;
                    var $response = $(response);

                    group.find(".group-names-container li.active").removeClass("active");

                    var deleteCategoryTranslation = window.ppt.translate("search.remove.category", "Kategorie löschen");
                    var showCategoryFilterTranslation = window.ppt.translate("search.filter.show", "Filter für Kategorie anzeigen");

                    group.find(".group-names-container").append(`
                        <li class="active"  data-group-id="${parent.id}" ${dataExternalId}>
                            <span class="filter-content">
                                <i class="remove-group" title="${deleteCategoryTranslation}">✕</i>
                                <span class="ttip-blue tooltipstered" title="${showCategoryFilterTranslation}">
                                     <span class="filter-name-group">
                                         <span class="filter-name"> ${parent.name}</span>
                                         <i class="icon-filter"></i>
                                     </span>
                                </span>
                            </span>
                            <input type="hidden" name="${headerHiddenName}" value="${parent.id}" />
                        </li>`);

                    window.pixelpoint.tooltip.init(group.find(".group-names-container li span"));
                    group.parent().parent().parent().find("button.search-button").html(window.ppt.translate("button.now.searchagain", "Erneut suchen!"));


                    groupContainer.find(".groups section.active").removeClass("active");
                    groupContainer.find(".groups").append($response);
                    groupContainer.find(`.groups [data-group-id="${parent.id}"]`).addClass("active");

                    groupContainer.find(`.groups section[data-group-id='${parent.id}'] .control .brandenbutton.search-button`).closest('.control').addClass("ignore");
                    var controlsCount = groupContainer.find(`.groups section[data-group-id='${parent.id}'] .control`).not(".ignore").length;
                    if (controlsCount == 0) {
                        groupContainer.find(".groups").css("height", 0);
                        return;
                    } else {
                        groupContainer.find(".groups").css("height", '');
                    }
                    index += 1;
                    group.data("count", index);

                    groupContainer.find(".groups").show();
                    var searchHeight = group.closest(".search").height();
                    var searchOffset = group.closest(".search").offset().top;
                    var groupOffset = groupContainer.find(".groups").offset().top;
                    var realHeight = searchHeight - (groupOffset - searchOffset);
                    groupContainer.find(".groups").css("max-height", realHeight);

                    window.ppComponents.select2.initialize($response.find('select.select2'));
                    window.ppComponents.select2.initializeRemote($response.find('select.autocomplete'));
                    window.ppComponents.common.showMore($response.find('.more-wrapper'));
                    window.ppComponents.common.sliders($response.find(".range-slider"));
                    window.ppComponents.radioGroup.init($response.find("[data-radio-group]"));
                    privateFunctions.recalculateGroupIndices(group);
                    privateFunctions.showHideTourLength();
                    privateFunctions.showHideTitle();
                    privateFunctions.showHideFilterIcon(group);
                    privateFunctions.addHideShowIcon(group, true);

                })
                .always(function () {
                    if (!!loaderFunctions)
                        loaderFunctions.hide();
                });
        },
        showHideFilterIcon(group) {
            group.find(".group-names-container li").each(function () {
                var groupContainer = privateFunctions.getGroupContainer(group);
                var groupId = $(this).data("group-id");
                if (!groupId) {
                    $(this).find(".icon-filter").addClass("hide");
                    return;
                }
                groupContainer.find(`.groups section[data-group-id='${groupId}'] .control .brandenbutton.search-button`).closest('.control').addClass("ignore");
                var controlsCount = groupContainer.find(`.groups section[data-group-id='${groupId}'] .control`).not(".ignore").length;
                if (controlsCount == 0) {
                    $(this).find(".icon-filter").addClass("hide");
                } else {
                    $(this).find(".icon-filter").removeClass("hide");
                }
            });
        },
        addHideShowIcon(group, initiallyOpen) {
            var groupContainer = privateFunctions.getGroupContainer(group);
            var count = $(".group-names-container li[data-group-id]").length;
            var list = group.find('ul.group-names-container');
            initiallyOpen = initiallyOpen || false;
            if (count > 6) {
                if (list.hasClass("showmore")) {
                    if (initiallyOpen) {
                        window.ppComponents.showMore.open(group.find("button.einklappen"));
                    }
                    return;
                }
                if (!initiallyOpen)
                    list.addClass("showmore collapsed");
                else
                    list.addClass("showmore");
                var id = group.data("input-group");
                list.data("id", id).attr("data-id", id);
                if (group.find("button.einklappen").length == 0) {
                    var active = 'active';
                    if (!!initiallyOpen)
                        active = '';
                    var showFilterTranslation = window.ppt.translate("filter.show", "Kategorienauswahl und Filter anzeigen");
                    //var filterTranslation = window.ppt.translate("filter","Kategorienauswahl & Filter");
                    var filterTranslation = window.ppt.translate("filter.open", "aufklappen");
                    var einklappenTranslation = window.ppt.translate("filter.collapse", "einklappen");
                    group.append(`<button class="einklappen ${active}" data-target="${id}" title="${showFilterTranslation}" aria-label="${showFilterTranslation}" data-close-title="${einklappenTranslation}" data-default-title="${showFilterTranslation}">                                            
                                        <div class="text">
                                            <span class="text1">${filterTranslation}</span>
                                            <span class="text2">${einklappenTranslation}</span>
                                        </div>
                                        <i class="icon-down-open-big" data-active="icon-up-open-big"></i>
                                    </button>`);
                } else {
                    group.find("button.einklappen").removeClass("hide");
                    if (!initiallyOpen) {
                        group.find("button.einklappen").addClass("active");
                    } else {
                        group.find("button.einklappen").removeClass("active");
                    }
                }
                window.ppComponents.common.showMore(list);// showMore.init(list);
            } else {
                if (!list.hasClass("showmore"))
                    return;
                list.removeClass("showmore");
                group.find("button.einklappen").addClass("hide");
            }
        }
    };

    window.pixelpoint.ppComponents.groupExtension = function ($this) {
        //var $this = $(this);
        var groupName = $this.data("group-selector");
        if (!groupName)
            return;
        var group = $(`[data-input-group='${groupName}']`);
        if (group.length == 0)
            return;
        var groupContainerParent = privateFunctions.getGroupContainer(group);
        var groupNames = group.find(".group-names-container");
        var groupContainer = groupContainerParent.find(".groups");

        if (groupNames.length == 0 || groupContainer.length == 0)
            return;

        var templateUrl = group.data("template-url");
        if (!templateUrl)
            return;

        privateFunctions.bindGroupEvents(group, $this);
        privateFunctions.showHideFilterIcon(group);

        privateFunctions.addHideShowIcon(group);

        if (!$this.is('[data-supress-group-creation]')) {
            if ($this.hasClass("select2-hidden-accessible")) {
                $this.on("select2:select", function (e) {
                    var data = $this.select2("data");
                    if (!!data) {
                        let allIds = [];
                        for (var i in data) {

                            var currentId = data[i].id;
                            var parts = currentId.split(":");
                            currentId = parts[0];
                            allIds.push(currentId);
                            var currentExternalId = parts.length > 1 ? parts[1] : "";

                            var parent = {
                                id: currentId,
                                externalId: currentExternalId,
                                name: data[i].text
                            };
                            privateFunctions.addGroupElement($this, group, parent, templateUrl);
                        }
                        window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.categoryChanged, [allIds]);
                    }
                    $this.val([]).trigger('change');
                });
            } else {
                $this.on("change", function () {
                    var parents = [];
                    $this.find(":selected").each(function () {
                        parents.push({
                            id: $(this).val(),
                            name: $(this).text()
                        });
                    });
                    for (var i in parents) {
                        privateFunctions.addGroupElement($this, group, parents[i], templateUrl);
                    }
                    $this.prop("selectedIndex", 0);
                });
            }
        }
    }

    $("[data-group-selector]").each(function () {
        window.pixelpoint.ppComponents.groupExtension($(this));
    });
});